import React, { useState, useEffect } from 'react';
import './Analytics.css';

interface AnalyticsProps {
  readOnly?: boolean;
}

const Analytics: React.FC<AnalyticsProps> = ({ readOnly = false }) => {
  const [embedUrl, setEmbedUrl] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!readOnly) {
      fetchEmbedUrl();
    } else {
      setLoading(false);
    }
  }, [readOnly]);

  const fetchEmbedUrl = async () => {
    try {
      const response = await fetch('https://api.productfootprint.awstommy.com/quicksight-embed');
      if (!response.ok) throw new Error('Failed to get embed URL');
      const data = await response.json();
      setEmbedUrl(data.embedUrl);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to load dashboard');
    } finally {
      setLoading(false);
    }
  };

  if (readOnly) {
    return (
      <div className="analytics-container">
        <div className="analytics-header">
          <h2>Production Analytics</h2>
          <p className="readonly-notice">Login required to view analytics dashboard</p>
        </div>
      </div>
    );
  }

  if (loading) {
    return (
      <div className="analytics-container">
        <div className="analytics-header">
          <h2>Production Analytics</h2>
          <p>Loading dashboard...</p>
        </div>
      </div>
    );
  }

  if (error || !embedUrl) {
    return (
      <div className="analytics-container">
        <div className="analytics-header">
          <h2>Production Analytics</h2>
          <p className="error-message">
            Dashboard not yet configured. Create visuals in QuickSight first.
          </p>
          <button 
            className="open-dashboard-btn"
            onClick={() => window.open('https://us-east-1.quicksight.aws.amazon.com/sn/analyses/production-carbon-footprint', '_blank')}
          >
            Open QuickSight
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="analytics-container">
      <div className="analytics-header">
        <h2>Production Analytics</h2>
      </div>
      <div className="dashboard-embed">
        <iframe
          src={embedUrl}
          width="100%"
          height="800px"
          frameBorder="0"
          title="Production Carbon Dashboard"
        />
      </div>
    </div>
  );
};

export default Analytics;
